import { ReferralRedirect } from '../../../components';
import { ShortUrlTableDataTypes } from '@requity-homes/data-types';

export default function PartnerReferralPage() {
  return ReferralRedirect({
    linkType: ShortUrlTableDataTypes.PARTNER_REFERRAL,
  });
}
